import React from 'react'

const PlaySvg = () => (
    <svg className="" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 4.63397C10.1667 5.01887 10.1667 5.98113 9.5 6.36603L2 10.6962C1.33333 11.0811 0.5 10.5999 0.5 9.83013L0.5 1.16987C0.5 0.400073 1.33333 -0.0810524 2 0.303848L9.5 4.63397Z" fill="#439ADE"/>
    </svg>
);

export default PlaySvg;